var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8292 16.0045L14.1684 12.3438C15.0784 11.2496 15.6266 9.84447 15.6266 8.31348C15.6266 4.83221 12.7944 2 9.31332 2C5.83213 2 3 4.83221 3 8.31348C3 11.7945 5.83213 14.6265 9.31332 14.6265C10.8442 14.6265 12.2494 14.0784 13.3436 13.1684L17.0045 16.8292C17.1183 16.9431 17.2676 17 17.4168 17C17.566 17 17.7153 16.9431 17.8292 16.8292C18.057 16.6014 18.057 16.2322 17.8292 16.0045ZM4.16638 8.31348C4.16638 5.47536 6.47528 3.16638 9.31332 3.16638C12.1513 3.16638 14.4601 5.47536 14.4601 8.31348C14.4601 11.1514 12.1513 13.4601 9.31332 13.4601C6.47528 13.4601 4.16638 11.1514 4.16638 8.31348Z",
    fill: "#33363F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/SearchIcon.7a0566580cd8801d8d1e82597826c3e9.svg";
export { ForwardRef as ReactComponent };